// extracted by mini-css-extract-plugin
export default {"buttongroup":"CalButtons_buttongroup__Qxva+","left":"CalButtons_left__DKQmE","middle":"CalButtons_middle__VXbMb","right":"CalButtons_right__U3zTM"};